// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"3c54b22d","345":"13ea9926","453":"8281a1ca","683":"28af1249"}[chunkId] + ".chunk.js";
};